interface IState {
  // id 当院内知识手册目录返回时
  // 存储用户选择的 id
  id: '' | number
}

export default {
  namespaced: true,
  state: <IState>{
    id: ''
  },
  getters: {},
  mutations: {
    setId(state: IState, payload: { id: '' | number }) {
      state.id = payload.id
    },
    clearId(state: IState) {
      state.id = ''
    }
  },
  actions: {}
}
